(() => {
  const holdout = () =>
    window._growthbook?.getFeatureValue("holdout-pdm-acl", "OFF");

  const readStatsCredentials = () => {
    const holdoutValue = holdout();

    if (holdoutValue === "holdout-h2-2026") {
      return;
    }

    document.body.setAttribute("data-stats-credentials", "true");
  };

  const readHomeComparisonTableSection = () => {
    if (window.location.pathname !== "/") {
      return;
    }

    const holdoutValue = holdout();

    if (holdoutValue === "holdout-h2-2026") {
      return;
    }

    document.body.setAttribute("data-test-home-comparison-table-section", "true");
  };

  const readMiniForm = () => {
    if (holdout() === "holdout-h2-2026") {
      return;
    }

    if (!window._growthbook.getFeatureValue("pdm-acl-mini-form", false)) {
      return;
    }

    console.log("mini form enabled");
    document.body.setAttribute("data-pdm-mini-form", "true");
  };

  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push(() => {
    const applyFeatureFlags = () => {
      readStatsCredentials();
      readHomeComparisonTableSection();
      readMiniForm();
    };

    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
})();
